var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.inventory.message.general") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-4" } },
                [
                  _c("Label", {
                    attrs: {
                      text: _vm.$t("apps.inventory.label.warehousename") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _c("BaseInput", {
                    attrs: {
                      classNames: [{ "is-invalid": _vm.$v.input.name.$error }],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.name, "$model", $$v)
                      },
                      expression: "$v.input.name.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.product.message.deductstockfrom") }
          }),
          _vm._v(" "),
          _vm._l(_vm.input.stockSkus, function(item, index) {
            return _c(
              "FormRow",
              { key: index, staticClass: "mb-2 form-control-mobile" },
              [
                _c(
                  "div",
                  { staticClass: "col-lg-4 mb-md-2 mb-2" },
                  [
                    _c("vue-bootstrap-autocomplete", {
                      attrs: {
                        data: item.sku_id
                          ? []
                          : _vm.optionSkus.filter(function(optionSkuItem) {
                              return !_vm.selectedSkuIds.includes(
                                optionSkuItem.value
                              )
                            }),
                        serializer: function(item) {
                          return item.text + " " + (item.sku_code || "")
                        },
                        minMatchingChars: 1,
                        maxMatches: 10,
                        placeholder: _vm.$t("placeholder.selectaproduct"),
                        loading: item.loading,
                        state: _vm.$v.input.stockSkus.$each[index].sku_id.$error
                          ? false
                          : null,
                        disabled: _vm.disabled,
                        showOnFocus: true,
                        noResultsInfo: !item.sku_id
                          ? _vm.$t("message.notfounddata")
                          : null,
                        showCreate: false
                      },
                      on: {
                        hit: function($event) {
                          return _vm.handleSelectProduct(index, $event)
                        },
                        blur: function($event) {
                          return _vm.handleBlurProduct(index, $event)
                        },
                        inputBlur: function($event) {
                          return _vm.handleInputBlurProduct(index, $event)
                        },
                        keydown: function($event) {
                          return _vm.handleKeydownProduct(index, $event)
                        },
                        keyup: function($event) {
                          return _vm.handleKeyupProduct(index, $event)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "suggestion",
                            fn: function(ref) {
                              var data = ref.data
                              var htmlText = ref.htmlText
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "40px",
                                        height: "40px",
                                        "border-radius": "0.25rem"
                                      },
                                      attrs: {
                                        src: _vm.productImage(data.value)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c("span", {
                                          staticClass: "ml-4",
                                          domProps: {
                                            innerHTML: _vm._s(data.text)
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "ml-4",
                                          staticStyle: { "font-size": "11px" },
                                          domProps: {
                                            innerHTML: _vm._s(data.sku_code)
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: item.query_product_name,
                        callback: function($$v) {
                          _vm.$set(item, "query_product_name", $$v)
                        },
                        expression: "item.query_product_name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-4 mb-md-2 mb-2" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("apps.product.message.warehouselocation")
                            ) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.location_id,
                            expression: "item.location_id"
                          }
                        ],
                        class: [
                          "form-control custom-select",
                          _vm.$v.input.stockSkus.$each[index].location_id
                            .$error && "is-invalid"
                        ],
                        attrs: { disabled: !item.sku_id || _vm.disabled },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                item,
                                "location_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function($event) {
                              return _vm.handleSelectLocationChange(
                                $event.target.value,
                                index
                              )
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("placeholder.select")) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.getLocationList(
                            _vm.getSkuInfoBySkuId(item.sku_id)
                          ),
                          function(locationItem, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                domProps: { value: locationItem.value }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(locationItem.text) +
                                    "\n            "
                                )
                              ]
                            )
                          }
                        )
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-3 mb-md-2 mb-2" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("apps.product.message.requiredunit")
                            ) +
                            "\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: item.required_unit,
                          expression: "item.required_unit"
                        }
                      ],
                      staticClass:
                        "form-control text-right number-only text-select-all",
                      attrs: {
                        disabled: _vm.disabled || !item.sku_id,
                        type: "text",
                        placeholder: ""
                      },
                      domProps: { value: item.required_unit },
                      on: {
                        keypress: _vm.numberOnly,
                        keyup: function($event) {
                          item.required_unit = _vm.setToValidNumber(
                            item.required_unit
                          )
                        },
                        blur: function($event) {
                          item.required_unit = _vm.setToCustomDigitsNumber(
                            item.required_unit
                          )
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(item, "required_unit", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                !_vm.disabled
                  ? _c("div", { staticClass: "col-lg-1 text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light col-12",
                          on: {
                            click: function($event) {
                              return _vm.deleteStockSku(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "far fa-trash-alt" })]
                      )
                    ])
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          !_vm.disabled
            ? _c("FormRow", [
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c(
                      "BaseButton",
                      {
                        attrs: { className: "btn-light" },
                        on: {
                          click: function($event) {
                            return _vm.addStockSku()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("button.addproduct")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Section",
        { staticClass: "mt-3" },
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("message.assignitems") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-12" } },
                [
                  !_vm.products.length
                    ? _c("BaseNotFoundData", {
                        attrs: {
                          title: _vm.$t("apps.inventory.message.notfoundskus"),
                          detail: _vm.$t(
                            "apps.inventory.message.createnewproducts"
                          )
                        }
                      })
                    : _c("BaseAssignSkus", {
                        attrs: {
                          items: _vm.assignItems,
                          disabled: _vm.disabled,
                          disabledItemMessage: false
                        },
                        model: {
                          value: _vm.input.assignSkus,
                          callback: function($$v) {
                            _vm.$set(_vm.input, "assignSkus", $$v)
                          },
                          expression: "input.assignSkus"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textCancel: _vm.$t("button.cancel"),
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onSubmit: _vm.handleSubmit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9316111c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9316111c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/RecipeForm.vue
// module id = null
// module chunks = 